import React, { useEffect, useState } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import OpenUrlButton from "./ButtonHref";

const apiScope = "api://e1cb820d-07a0-43d1-ba40-9fbec2d65688/access_as_user";

interface FormData {
  name: string;
  email: string;
  emailGraph: string;
  company: string;
  title: string;
  departmentName: string;
}

const UserForm: React.FC = () => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    emailGraph: "",
    company: "",
    title: "",
    departmentName: "",
  });

  useEffect(() => {
    if (account) {
      setFormData((prev) => ({
        ...prev,
        name: account.name || "",
        email: account.username || "",
      }));
    }
  }, [account]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Formulärdata:", formData);
  };

  const clearForm = () => {
    console.log("ClearForm:", formData);
    setFormData((prev) => ({
      ...prev,
      emailGraph:  "",
      company:  "",
      title:  "",
      departmentName:  "",
    }));
  };

  const fetchEmailFromGraph = async () => {
    if (!account) return;

    setFormData((prev) => ({
        ...prev,
        emailGraph:  "",
      }));

    try {
      const response = await instance.acquireTokenSilent({
        scopes: loginRequest.scopes,
        account: account,
      });

      const accessToken = response.accessToken;

      const graphResponse = await fetch("https://graph.microsoft.com/v1.0/me", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await graphResponse.json();

      setFormData((prev) => ({
        ...prev,
        emailGraph: data.mail || data.userPrincipalName || prev.emailGraph,
      }));
    } catch (error) {
      console.error("Kunde inte hämta e-post från Graph API:", error);
    }
  };

  const fetchUserInfoFromFunctionApp = async () => {
    try {
      setFormData((prev) => ({
        ...prev,
        company:  "",
        title:  "",
        departmentName:  "",
      }));

      const account = instance.getAllAccounts()[0]; // aktuella användaren
      const response = await instance.acquireTokenSilent({
        scopes: [apiScope],
        account: account
      });
      const accessToken = response.accessToken;
      // Anropa Function API
      console.log("Anropar Function App med token:", account);
      const result = await fetch("https://func-my-app-api-acbya6aab3bvgqfe.swedencentral-01.azurewebsites.net/api/GetUserInfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });


      const data = await result.json();

      setFormData((prev) => ({
        ...prev,
        company: data.company || prev.company,
        title: data.title || prev.title,
        departmentName: data.department || prev.departmentName,
      }));
    } catch (error) {
      console.error("Kunde inte hämta användarinformation från Function App:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Name:</label>
        <input name="name" value={formData.name} onChange={handleChange} readOnly  required />
      </div>
      <div>
        <label>UPN (MSAL):</label>
        <input name="email" value={formData.email} readOnly />
      </div>
      <div>
        <label>Email - Graph API:</label>
        <input name="emailGraph" value={formData.emailGraph} readOnly />
      </div>
      <div>
        <label>Company:</label>
        <input name="company" value={formData.company} onChange={handleChange} />
      </div>
      <div>
        <label>Title:</label>
        <input name="title" value={formData.title} onChange={handleChange} />
      </div>
      <div>
        <label>Department Name:</label>
        <input name="departmentName" value={formData.departmentName} onChange={handleChange} />
      </div>
      <div>
        <button type="button" onClick={fetchEmailFromGraph}>
          Hämta e-post från Graph API
        </button>
        <button type="button" onClick={fetchUserInfoFromFunctionApp}>
          Hämta info från Function App
        </button>
      </div>
      <div>
        {/*<button type="submit">Rensa2</button>  */}
        <button type="button" onClick={clearForm}>Rensa</button>  {/**/}
        {/**/}
        
        {/*
        <OpenUrlButton label="Open SPo" url="https://gruvrosse.sharepoint.com/sites/REACT-MyApp/Lists/Info/AllItems.aspx" />
        */}
        
        {account?.idTokenClaims?.roles?.includes("Admins") && (
          <OpenUrlButton label="Open SPo" url="https://gruvrosse.sharepoint.com/sites/REACT-MyApp/Lists/Info/AllItems.aspx" />
        )}
        

        
      </div>
    </form>
  );
};

export default UserForm;